/* eslint-disable @trello/disallow-filenames */
/* eslint-disable @trello/export-matches-filename */

export const DND_NEW_EVENT_DURATION_IN_MINUTES = 30;
export const DND_TEMP_EVENT_ID_PREFIX = 'DRAGGED-TEMP-EVENT-ID-';
export const CLICK_TEMP_DRAFT_ID = 'CLICK-EVENT-DRAFT-TEMP-ID';
export const CLICK_TEMP_OPTIMISTIC_ID_PREFIX =
  'CLICK-EVENT-OPTIMISTIC-TEMP-ID-';
export const PROPOSED_EVENT_ID_PREFIX = 'PROPOSED-EVENT-ID-';
export const CARD_QUICK_ACTIONS_TEMP_OPTIMISTIC_ID_PREFIX =
  'CARD-QUICK-ACTIONS-EVENT-OPTIMISTIC-TEMP-ID-';
export const CUSTOM_VIEW_KEY_PREFIX = 'planner:custom_view';
export const WEEKEND_VIEW_KEY_PREFIX = 'planner:weekend_view';
export const GOOGLE_SERVICE_KEY = 'trello-planner-google-calendar';
export const OUTLOOK_SERVICE_KEY = 'trello-planner-outlook-calendar';
